import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FbTabpanelButtonComponent } from './fb-tabpanel-button.component';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';

@NgModule({
  imports: [
    CommonModule,
    TabViewModule,
    ToastModule
  ],
  declarations: [FbTabpanelButtonComponent],
  exports : [FbTabpanelButtonComponent]
})
export class FbTabpanelButtonModule { }
